module.exports = __webpack_public_path__ + "public/images/about-exhibition/bg-desktop.7d558c82ea246861b712a7c63baf1cd2.svg";